import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const RECENT_KEY = 'viewed_models_ids';

interface State {
  recentlyViewedIds: string[];
}

const loadState = (): string[] => {
  try {
    const serialized = localStorage.getItem(RECENT_KEY);
    return serialized ? JSON.parse(serialized) : [];
  } catch (e) {
    return [];
  }
};

const initialState: State = {
  recentlyViewedIds: loadState(),
};

export const resourcesHistorySlice = createSlice({
  name: 'resourcesHistory',
  initialState,
  reducers: {
    addRecentlyViewedModel: (state, action: PayloadAction<string>) => {
      const modelId = action.payload;

      state.recentlyViewedIds = state.recentlyViewedIds.filter(
        id => id !== modelId,
      );

      state.recentlyViewedIds.unshift(modelId);

      if (state.recentlyViewedIds.length > 8) {
        state.recentlyViewedIds.length = 8;
      }

      localStorage.setItem(RECENT_KEY, JSON.stringify(state.recentlyViewedIds));
    },
  },
});

export const { addRecentlyViewedModel } = resourcesHistorySlice.actions;
